import React from "react";
import { Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";

const FlagComponent = () => {
  const { formatMessage, locale } = useIntl();
  const isArabic = locale === "ar";
  const text = formatMessage({ id: "new" });

  return (
    <Box
      position="absolute"
      top="50%"
      left="8px"
      transform="translateY(-50%)"
      zIndex="10"
      display="flex"
      alignItems="center"
      flexDirection="row-reverse"
      style={{ pointerEvents: "none" }}
    >
      {/* Rectangular Flag */}
      <Box
        background="#880002"
        color="white"
        fontSize="10px"
        fontWeight="bold"
        px={!isArabic ? "14px" : "16px"}
        py="2px"
        height="22px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        minW="35px"
        maxWidth="40px"
        position="relative"
        boxShadow="0 3px 10px rgba(0,0,0,0.3)"
        transform={!isArabic ? "scaleX(-1)" : undefined}
        style={{
          clipPath: "polygon(14% 0%, 100% 0%, 85% 50%, 100% 100%, 0% 100%)",
        }}
        zIndex="1"
      >
        <span style={{ transform: !isArabic ? "scaleX(-1)" : undefined }}>
          {text}
        </span>
      </Box>
    </Box>
  );
};

export default FlagComponent;
